try{self['workbox:sw:6.5.3']&&_()}catch(e){}// eslint-disable-line